import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../lib/api';

export default function RelatedIdeas({ ideaId }) {
  const [related, setRelated] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!ideaId) return;
    api.get(`/ideas/${ideaId}/related/`)
      .then((res) => setRelated(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [ideaId]);

  if (loading || related.length === 0) return null;

  return (
    <div className="border-t border-gray-200 dark:border-gray-800 p-3">
      <h3 className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-2">Related Ideas</h3>
      <div className="space-y-1">
        {related.map((idea) => (
          <Link
            key={idea.id}
            to={`/ideas/${idea.id}`}
            className="block text-xs text-indigo-600 dark:text-indigo-400 hover:underline truncate"
          >
            {idea.title || 'Untitled'}
          </Link>
        ))}
      </div>
    </div>
  );
}
